import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import NotificationDropdown from '../notifications/NotificationDropdown';

const AdminHeader = () => {
  const { profile } = useAuth();
  const isAdmin = profile?.role === 'admin';

  return (
    <header className="bg-white border-b border-gray-200 h-16 flex items-center justify-between px-6 sticky top-0 z-30">
      <div>
        <h1 className="text-lg font-semibold text-dark-900">
          {isAdmin ? 'Painel Administrativo' : 'Portal da Cervejaria'}
        </h1>
        {profile?.brewery && (
          <p className="text-xs text-dark-500">
            {profile.brewery.name}
          </p>
        )}
      </div>
      
      <div className="flex items-center space-x-4">
        {profile?.brewery && (
          <div className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider ${profile.brewery.is_active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
            {profile.brewery.is_active ? 'Loja Aberta' : 'Loja Fechada'}
          </div>
        )}
        
        {/* Notification Component */}
        <NotificationDropdown />
        
        <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center text-white font-bold text-sm">
          {profile?.full_name?.charAt(0) || 'A'}
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;